import * as React from 'react';
import * as styles from '../../help/help.module.scss';

interface Props {
  text: string;
  backgroundColor: string;
}

const StatusChip = ({ text, backgroundColor }: Props) => {
  return (
    <span className={styles.statusChip} style={{ backgroundColor }}>
      {text}
    </span>
  );
};

export default StatusChip;
